/**
 * [sc-48538 / task 48561] Il «totale ordine» da cui parte il riepilogo del PDF.
 *
 * È il valore delle righe, maggiorazione compresa, **prima** di sconto,
 * acconto e imballo: quei tre il documento li sottrae o li aggiunge da sé,
 * subito dopo.
 *
 * Prima, quando c'era una maggiorazione, si partiva da `realTotalPrice`, che
 * dal server arriva già al netto di sconto e acconto e già comprensivo
 * dell'imballo: il documento li applicava una seconda volta. Qui invece si
 * parte dal totale delle righe e si somma la sola maggiorazione, che è l'unica
 * cosa che le righe non contengono.
 */

const round2 = (n) => Number(Number(n || 0).toFixed(2));

export function orderTotalOf(
  quote,
  { rowsItemsTotal = 0, hasLineDiscount = false } = {}
) {
  // Se una riga porta uno sconto suo, il totale deriva dalla somma delle righe
  // (già scontate), per coerenza con la tabella stampata sopra.
  const items =
    hasLineDiscount && Number(rowsItemsTotal) > 0
      ? Number(rowsItemsTotal)
      : Number(quote?.totalPrice || 0);

  const surcharge = Number(quote?.surcharge || 0);
  const maggiorazione =
    Number.isFinite(surcharge) && surcharge > 0 ? surcharge : 0;

  return round2((Number.isFinite(items) ? items : 0) + maggiorazione);
}

export default orderTotalOf;
